import api from "../api/axios";

const url = ``;

export const getEmployeesResignations = async (
  company_id,
  filter = "",
  filter_id = ""
) => {
  try {
    const params = new URLSearchParams();
    params.append(filter, filter_id);

    const response = await api.get(
      `${url}employees-resignations/${company_id}?${params.toString()}`
    );
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};

export const getResignations = async (company_id, filter, filter_id) => {
  try {
    const params = new URLSearchParams();
    params.append(filter, filter_id);

    const response = await api.get(
      `${url}resignations-details/${company_id}?${params.toString()}`
    );

    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    console.error("Error fetching resignations:", error);
    throw error;
  }
};

export const applyResignation = async (data) => {
  try {
    const response = await api.post(`${url}apply-resignation`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const resignationApproval = async (approvalId, data) => {
  try {
    const response = await api.put(
      `${url}resignations-approval/${approvalId}`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const employeesPendingSettlements = async (filter, filter_id) => {
  try {
    const params = new URLSearchParams();
    params.append(filter, filter_id);

    const response = await api.get(
      `${url}employees-pending-settlements?${params.toString()}`
    );
    if (response && response.data) {
      return response.data.data[0];
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};

export const saveFNFSettlement = async (data) => {
  try {
    const response = await api.post(`${url}fnf-settlements`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const settlementsForVerification = async (
  company_id,
  filter,
  filter_id
) => {
  try {
    const params = new URLSearchParams();
    params.append(filter, filter_id);

    const response = await api.get(
      `${url}fnf-settlements-verification/${company_id}?${params.toString()}`
    );
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};

export const fnfSettlementsApproval = async (data) => {
  try {
    const response = await api.put(`${url}approve-fnf-settlements`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSalaryHoldTypes = async () => {
  try {
    const response = await api.get(`${url}get-salary-hold-types`);
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response");
  } catch (error) {
    throw error;
  }
};

export const getFNFDeductionComponents = async () => {
  try {
    const response = await api.get(`${url}get-fnf-components`);
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response");
  } catch (error) {
    throw error;
  }
};

export const addFNFDeductionComponent = async (data) => {
  try {
    const response = await api.post(`${url}add-fnf-deduction-component`, data);
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response");
  } catch (error) {
    throw error;
  }
};

export const applyForResignationWithdrawal = async (
  resignation_id,
  updated_by , status = "resignation" , employee_id  = null
) => {
  try {
    const response = await api.put(
      `${url}withdraw-resignation/${resignation_id}?status=${status}&employee_id=${employee_id}`,
      { updated_by: updated_by }
    );
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response");
  } catch (error) {
    throw error;
  }
};

export const terminateEmployee = async (data) => {
  try {
    const response = await api.post(`${url}terminate-employee`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getFnfSettlementApprover = async (company_id, employee_id) => {
  try {
    const params = new URLSearchParams();
    params.append("employee_id", employee_id);

    const response = await api.get(
      `${url}fnf-settlement-approver/${company_id}?${params.toString()}`
    );
    if (response && response.data) {
      return response.data;
    }
    throw new Error("Unexpected response format");
  } catch (error) {
    throw error;
  }
};
